module.exports = __webpack_public_path__ + "static/FuturaPT-Bold-9d2b3b49fdbaf67b82b3bdfb098479a7.woff";